import React from "react";
import { FaRoute } from "react-icons/fa";

export const RouteButton = (props) => {
  const { onClick } = props;

  const className = `bg-white text-blue-500 hover:bg-blue-500 hover:text-white
            flex items-center justify-center
            hover:cursor-pointer border-gray-200 h-full p-2 border-l`;

  return (
    <div className={className} onClick={onClick}>
      <button className="text-lg">
        <FaRoute />
      </button>
    </div>
  );
};
